function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBedFutonFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-6c-1.1 0-2-.9-2-2V7zm8 0h-6v2h6V7zM7 2c-1.1 0-2 .9-2 2v11.1l-1.1.7c-.6.4-.9 1-.9 1.7V28c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V14c0-1.1-.9-2-2-2V4c0-1.1-.9-2-2-2H7zm18 10V4H7v9.8l2.2-1.5c.3-.2.7-.3 1.1-.3H25zM9.5 14.5l-2.9 2h2.9v-2zm-4.5 4V28h22V14H11.5v3.3c0 .7-.5 1.2-1.2 1.2H5z",
    fill: props.color
  }));
}

export default SvgIconBedFutonFilled;